<template>
    <b-card
     class="bg-ligth-brown shadow"
     id="selected-box"
    >
      <ul class="list-inline mb-0">
        <li class="list-inline-item">
          <p class="mb-0"><b-badge variant="primary">{{ results.length }}</b-badge> - <b> <translate>Selected packages</translate></b></p>
        </li>
        <li class="list-inline-item">
          <b-btn variant="primary" size="sm" @click="$emit('info')" v-translate>Generate PDF</b-btn>
        </li>
        <li class="list-inline-item">
          <b-btn class="btn-sm btn-danger" @click="$emit('hide')">
            <b-icon icon="x"/>
          </b-btn>
        </li>
      </ul>
    </b-card>
</template>

<script>
export default {
  name: 'selectedResults',
  props: ['results']
}
</script>
